import { render, staticRenderFns } from "./project-activities.vue?vue&type=template&id=8ab436d4&scoped=true&"
import script from "./project-activities.vue?vue&type=script&lang=js&"
export * from "./project-activities.vue?vue&type=script&lang=js&"
import style0 from "./project-activities.vue?vue&type=style&index=0&id=8ab436d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab436d4",
  null
  
)

export default component.exports